import request from "./request";

const DocumentTypeService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/documenttype/all`, context.token, signal);
    },
    GetDocumentTypes: async (context, signal) => {
        return await request.sendRequest(`/documenttype/all/types`, context.token, signal);
    },
    GetDocumentTags: async (context, signal) => {
        return await request.sendRequest(`/documenttype/all/tags`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/documenttype/${id}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/documenttype`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/documenttype/${id}`, context.token);
    },
};

export default DocumentTypeService;
